import { useCallback, useEffect, useRef, useState } from 'react';
import { notification } from '@spark/ui-components/utils/notification';
import { getSupersetGuestToken } from '@spark/services/superset';

export const useSupersetDashboardToken = (dashboardUuid) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const isMountedRef = useRef(true);
  const tokenRef = useRef(null);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getSupersetGuestToken(dashboardUuid);
      const payload = response?.data || response || {};

      if (!payload?.token || !payload?.instanceUrl || !payload?.dashboardUuid) {
        throw new Error('Resposta invalida ao obter guest token do Superset.');
      }

      if (!isMountedRef.current) return payload;
      tokenRef.current = payload.token;
      setData(payload);
      return payload;
    } catch (err) {
      if (!isMountedRef.current) return null;
      const message = err?.response?.data?.error || err?.message || 'Erro ao carregar dashboard';
      notification.error(message);
      setError(message);
      setData(null);
      tokenRef.current = null;
      return null;
    } finally {
      if (isMountedRef.current) setLoading(false);
    }
  }, [dashboardUuid]);

  useEffect(() => {
    load();
  }, [load]);

  const fetchGuestToken = useCallback(async () => {
    const response = await getSupersetGuestToken(dashboardUuid);
    const payload = response?.data || response || {};

    if (!payload?.token) {
      throw new Error('Nao foi possivel obter guest token do Superset.');
    }

    tokenRef.current = payload.token;
    if (isMountedRef.current) {
      setData(payload);
      setError(null);
    }

    return payload.token;
  }, [dashboardUuid]);

  return { loading, data, error, reload: load, fetchGuestToken };
};
